<template>
    <div>
        <innerheader />
        <alertpage />
    </div>
</template>

<script>
// @ is an alias to /src
import innerheader from "@/components/innerheader/innerheader.vue";
import alertpage from "@/components/alert/alertpage.vue";

export default {
  name: 'alert',
  components: {
     innerheader,
     alertpage
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/scss/components/paymentsuccess.scss';
</style>